// Import the necessary functions and components
import { ref } from "vue";
import { useRouter } from "vue-router";

export default function() {
  const router = useRouter();
  // Create a ref to store the previous route path
  const previousRoutePath = ref("");
  // Use the router's navigation guard to track route changes
  router.beforeEach((to, from, next) => {
    previousRoutePath.value = from.fullPath;
    next();
  });
  return {
    router,
    previousRoutePath
  };
}